import { configureLocalization, LocaleModule } from "@lit/localize";

import { allLocales, sourceLocale, targetLocales } from "../generated/locale-codes";

import * as templates_pt_br from '../generated/locales/pt-BR';
import * as templates_en from '../generated/locales/en';
import * as templates_es_419 from '../generated/locales/es-419';


const localizedTemplates = new Map<string, LocaleModule>([
  ['en', templates_en],
  ['pt-BR', templates_pt_br],
  ['es-419', templates_es_419],
]);




const config = configureLocalization({
  sourceLocale,
  targetLocales,
  loadLocale: async (locale) => localizedTemplates.get(locale)!,
});

export const localeService = {
    ...config,
    setBestMatchLocale: (locales: readonly string[]) => {
        for (const locale of locales) {
            if (allLocales.includes(locale as never)) {
                config.setLocale(locale);
                return;
            }
        }
        // fallback
        config.setLocale('en');
    }
}
